<!-- 排产操作日志 -->
<style scoped="scoped" lang="scss"></style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/aps/scheduling/operation/log/page" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('caozuoshijian')">
            <yi_time_input type="datetimerange" :start.sync="yt.conditions.createTimeStart" :end.sync="yt.conditions.createTimeEnd"> </yi_time_input>
          </el-form-item>
          <el-form-item :label="$t('caozuoren')">
            <yi_data_select :multiple="true" :type="'customer_user'" :ids.sync="yt.conditions.userIds" :title="username,"> </yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('caozuomiaoshu')">
            <yi_dictionary_select :type="'APS_OPERATION_DESC'" :ids.sync="yt.conditions.name"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear({ createTimeStart: createTimeStart, createTimeEnd: createTimeEnd })">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-export" :title="$t('daochu')" @click="exportExcel()"></el-button>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
      </template>
    </yi_curd_table>
  </div>
</template>

<script type="text/javascript">
export default {
  name: 'web_scheduling_operation_log_list',
  data() {
    return {
      createTimeStart: 0,
      createTimeEnd: 0,
      columns: [
        {
          label: 'caozuoshijian',
          prop: 'createTime',
          type: 'time',
          format: 'YYYY-MM-DD HH:mm:ss'
        },
        {
          label: 'yonghuzhanghao',
          prop: 'createByObject.username'
        },
        {
          label: 'yonghumingcheng',
          prop: 'createByObject.nickname'
        },
        {
          label: 'caozuomiaoshu',
          prop: 'name',
          type: 'dictionary',
          key: 'APS_OPERATION_DESC'
        }
      ]
    };
  },
  created() {
    setTimeout(() => {
      this.setStartAndEndTimes();
      this.yt.get(1);
    }, 300);
  },

  methods: {
    exportExcel() {
      let params = this.yt.conditions;
      // params.materialId = this.yt.conditions.materialIdList;
      // params.equipmentId = this.yt.conditions.equipmentIdList;
      // params.status = this.yt.conditions.statusList;
      // delete params.materialIdList;
      // delete params.equipmentIdList;
      // delete params.statusList;
      // delete params.orderBy;
      return this.http
        .get('/web/report/export/aps_scheduling_log_export', { params })
        .then(res => {
          this.$message.success(this.$t(res.msg));
          this.utils.event_hub.$emit('SHOW_HEADER_EXPORT_DIALOG');
        })
        .catch(error => {
          this.$message.error(this.$t(error));
        });
    },
    setStartAndEndTimes() {
      const currentDate = new Date();
      const year = currentDate.getFullYear();
      const month = currentDate.getMonth();

      // Calculate the first day of the current month
      const firstDayOfMonth = new Date(year, month, 1);
      firstDayOfMonth.setHours(0, 0, 0);

      // Calculate the last day of the current month
      const lastDayOfMonth = new Date(year, month + 1, 0);
      lastDayOfMonth.setHours(23, 59, 59);

      // Set yt.conditions.startTime and yt.conditions.endTime
      this.createTimeStart = firstDayOfMonth.getTime();
      this.createTimeEnd = lastDayOfMonth.getTime();
      this.yt.conditions.createTimeStart = firstDayOfMonth.getTime();
      this.yt.conditions.createTimeEnd = lastDayOfMonth.getTime();
    }
  }
};
</script>
